import { useIntl } from 'react-intl';

import { SearchInput } from '@provider-portal/design-common/clay/components/SearchInput';

export type StoreSelectorSearchStrings = Record<'searchPlaceholder', string>;
export interface StoreSelectorSearchProps {
  onSearch: (search: string) => void;
}

export function StoreSelectorSearch({ onSearch }: StoreSelectorSearchProps) {
  const intl = useIntl();

  return (
    <SearchInput
      className="mb-3"
      searchLabel={intl.formatMessage({ id: 'venueSelector.search.placeholder' })}
      clearLabel={intl.formatMessage({ id: 'components.Notifications.clear' })}
      onChange={onSearch}
    />
  );
}
